// extracted by mini-css-extract-plugin
export var productImage = "_n9-1";
export var viewLink = "_n9-2";
export var wishlistItem = "_n9-0";